import React, { useState } from "react";
import { BellRing, Smartphone } from "lucide-react";
import { useUpozorneni } from "../lib/upozorneniKontext";

const SKRYTO = "pp-push-skryto";

/**
 * Zapnutí upozornění na tomto zařízení. `karta` = ve zvonečku (jde odložit „Teď ne“),
 * `radek` = krátká věta pod přepínačem „Upozornit v čas úkolu“ ve formuláři.
 * Na iPhonu bez aplikace na ploše jen poradí, jak ji tam přidat.
 */
export default function ZapnoutUpozorneni({ varianta = "karta" }) {
  const { push, zapnout } = useUpozorneni();
  const [skryto, setSkryto] = useState(() => {
    try { return localStorage.getItem(SKRYTO) === "1"; } catch { return false; }
  });
  const [zapinam, setZapinam] = useState(false);
  const [chyba, setChyba] = useState(false);
  if (push === "zapnuto" || push === "nejde") return null;

  const klik = async () => {
    setZapinam(true);
    setChyba((await zapnout()) === "chyba");
    setZapinam(false);
  };
  const hlaska = chyba && <span className="block t-meta text-danger">Upozornění se nepodařilo zapnout. Zkus to znovu, v anonymním okně nejdou.</span>;
  const text = {
    vypnuto: "Úkol ti blikne na telefonu nebo v počítači, i když máš aplikaci zavřenou.",
    "ios-plocha": "Na iPhonu nejdřív přidej ProfitPilot na plochu: Sdílet → Přidat na plochu. Otevři ho z plochy a upozornění zapneš tady.",
    zakazano: "Upozornění máš v prohlížeči zakázaná. Povol je v nastavení prohlížeče u téhle stránky.",
  }[push];

  if (varianta === "radek") {
    return push === "vypnuto" ? (
      <>
        <button type="button" onClick={klik} disabled={zapinam} data-testid="zapnout-upozorneni-radek"
          className="tap md:min-h-0 self-start inline-flex items-center gap-1.5 t-meta font-700 text-accent hover:text-accent-hover disabled:opacity-60">
          <BellRing size={14} strokeWidth={2.2} /> Zapnout upozornění na tomto zařízení
        </button>
        {hlaska}
      </>
    ) : <span className="t-meta text-muted">{text}</span>;
  }

  if (skryto) return null;
  const odlozit = () => {
    try { localStorage.setItem(SKRYTO, "1"); } catch { /* bez paměti */ }
    setSkryto(true);
  };
  const Ikona = push === "ios-plocha" ? Smartphone : BellRing;
  return (
    <div className="bg-white rounded-[20px] p-3.5 mb-3 flex items-start gap-3" data-testid="zapnout-upozorneni">
      <span className="h-9 w-9 rounded-[11px] bg-accent/15 text-[#a8410c] inline-flex items-center justify-center shrink-0">
        <Ikona size={17} strokeWidth={2} />
      </span>
      <div className="flex-1 min-w-0">
        <div className="t-telo font-700 text-ink">Upozornění na tomto zařízení</div>
        <p className="t-meta text-muted mt-0.5">{text}</p>
        {hlaska}
        <div className="flex items-center gap-1 mt-2 -ml-1">
          {push === "vypnuto" && (
            <button type="button" onClick={klik} disabled={zapinam} data-testid="zapnout-upozorneni-tlacitko"
              className="tap lg:min-h-0 h-9 px-4 rounded-full bg-accent text-white t-meta font-700 hover:bg-accent-hover disabled:opacity-60">
              Zapnout
            </button>
          )}
          <button type="button" onClick={odlozit} data-testid="zapnout-upozorneni-ne"
            className="tap lg:min-h-0 h-9 px-3 rounded-full t-meta font-600 text-sec hover:text-ink">
            Teď ne
          </button>
        </div>
      </div>
    </div>
  );
}
